// worker thread
import * as Comlink from "comlink";
import posSharedLib from "@coretech/pos-shared-lib";
Comlink.expose(posSharedLib);
